export var ACTION;
(function (ACTION) {
    ACTION["CHANGE_TAB"] = "CHANGE_TAB";
    ACTION["OPEN_MENU"] = "OPEN_MENU";
    ACTION["SHARE_LINK_REF"] = "SHARE_LINK_REF";
})(ACTION || (ACTION = {}));
